import { FormError, TextMessage } from '@/constant';
import { CommonActions } from '@/stores';
import { showAlert } from '@/utils';
import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';

import { FormikProps } from 'formik';

export const useLogic = (
	formik: FormikProps<{ [key: string]: any }>,
	fieldName: string = 'subDomain'
) => {
	const dispatch = useDispatch();

	const getAdditionalValues = useCallback(() => {
		return {
			isVerifyDomain: false,
			isValidDomain: false,
			hasDomainServerError: false,
		};
	}, []);

	const verifyDomain = useCallback(async () => {
		if (formik.errors[fieldName] === FormError.REQUIRED) {
			formik.setFieldTouched(fieldName, true);
			return showAlert(TextMessage.ALERT_12);
		}
		if (formik.errors[fieldName] === FormError.FORMAT) {
			formik.setFieldTouched(fieldName, true);
			return showAlert(TextMessage.ALERT_13);
		}
		dispatch(
			CommonActions.verifyDomainRequest({
				domain: formik.values[fieldName]?.trim(),
				callback: (params) => {
					if (params?.error) {
						formik.setValues((pre: { [key: string]: any }) => ({
							...pre,
							isValidDomain: false,
							isVerifyDomain: true,
						}));
						return;
					}
					formik.setValues((pre: { [key: string]: any }) => ({
						...pre,
						isValidDomain: true,
						isVerifyDomain: true,
					}));
					formik.setFieldTouched(fieldName, false);
				},
			})
		);
	}, [formik]);

	const isAvailableDomain = useMemo(() => {
		const isVerifiedDomain = formik?.values?.isVerifyDomain;
		const isValid = formik?.values?.isValidDomain;

		if (!isVerifiedDomain) return undefined;
		return isValid;
	}, [formik?.values?.isValidDomain, formik?.values?.isVerifyDomain]);

	return {
		verifyDomain,
		getAdditionalValues,
		isAvailableDomain,
	};
};
